module.exports = {
          srcSet: "/_next/static/images/user1-146-542b21f7104a40194840e0547f248db1.jpg"+" 146w",
          images:[ {path: "/_next/static/images/user1-146-542b21f7104a40194840e0547f248db1.jpg",width: 146,height: 146}],
          src: "/_next/static/images/user1-146-542b21f7104a40194840e0547f248db1.jpg",
          toString:function(){return "/_next/static/images/user1-146-542b21f7104a40194840e0547f248db1.jpg"},
          
          width: 146,
          height: 146
        }